var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"non-member-rewards"},[_c('cmg-member-loyalty-rewards'),_c('cmg-recaptcha')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }